// REST /api/canvases/:canvasId からキャンバススナップショットを取得して store にロードする。
// 失敗時（404 で実体未作成）は空キャンバスとしてストアを初期化する。

import { useEffect } from "react";
import { useCanvasDocStore } from "./store/canvas-doc-store";
import { useCanvasApi } from "../../lib/canvas-api";

export function useCanvasBootstrap(canvasId: string): void {
  const canvasApi = useCanvasApi();
  const loadSnapshot = useCanvasDocStore((s) => s.loadSnapshot);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        const data = await canvasApi.fetchCanvasBootstrap(canvasId);
        if (cancelled) return;
        loadSnapshot({
          canvasId: data.canvasId,
          serverSeq: data.serverSeq,
          objects: [...data.objects],
          meta: data.meta,
        });
      } catch (e) {
        // 例外時もローカルでは空のスナップショットでスタートし、
        // 最初の op を送ったタイミングでサーバ側に実体化される設計（lazy create）。
        console.warn("[bootstrap] 取得失敗、空キャンバスで開始します", e);
        loadSnapshot({ canvasId, serverSeq: 0, objects: [] });
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [canvasApi, canvasId, loadSnapshot]);
}
